var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TimelineBoxAdapter_terminator, _TimelineBoxAdapter_box, _TimelineBoxAdapter_markerTrack, _TimelineBoxAdapter_signatureTrack, _TimelineBoxAdapter_tempoTrackEvents, _TimelineBoxAdapter_tempoAutomation, _TimelineBoxAdapter_resolveTempoAutomation;
import { MutableObservableOption, Notifier, Option, Terminator } from "@opendaw/lib-std";
import { MarkerTrackAdapter } from "./MarkerTrackAdapter";
import { SignatureTrackAdapter } from "./SignatureTrackAdapter";
import { PPQN } from "@opendaw/lib-dsp";
import { ValueEventCollectionBoxAdapter } from "./collection/ValueEventCollectionBoxAdapter";
export class TimelineBoxAdapter {
    constructor(context, box) {
        _TimelineBoxAdapter_terminator.set(this, new Terminator());
        _TimelineBoxAdapter_box.set(this, void 0);
        _TimelineBoxAdapter_markerTrack.set(this, void 0);
        _TimelineBoxAdapter_signatureTrack.set(this, void 0);
        _TimelineBoxAdapter_tempoTrackEvents.set(this, void 0);
        _TimelineBoxAdapter_tempoAutomation.set(this, void 0);
        _TimelineBoxAdapter_resolveTempoAutomation.set(this, () => {
            const { tempoTrack: { enabled } } = __classPrivateFieldGet(this, _TimelineBoxAdapter_box, "f");
            if (!enabled.getValue()) {
                return Option.None;
            }
            else if (__classPrivateFieldGet(this, _TimelineBoxAdapter_tempoTrackEvents, "f").isEmpty()) {
                return Option.None;
            }
            else if (__classPrivateFieldGet(this, _TimelineBoxAdapter_tempoTrackEvents, "f").unwrap().events.isEmpty()) {
                return Option.None;
            }
            else {
                return (__classPrivateFieldGet(this, _TimelineBoxAdapter_tempoTrackEvents, "f"));
            }
        });
        __classPrivateFieldSet(this, _TimelineBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _TimelineBoxAdapter_markerTrack, new MarkerTrackAdapter(context, box.markerTrack), "f");
        __classPrivateFieldSet(this, _TimelineBoxAdapter_signatureTrack, new SignatureTrackAdapter(context, box.signature, box.signatureTrack), "f");
        __classPrivateFieldSet(this, _TimelineBoxAdapter_tempoTrackEvents, new MutableObservableOption(), "f");
        __classPrivateFieldSet(this, _TimelineBoxAdapter_tempoAutomation, new Notifier(), "f");
        const tempoAutomationLifecycle = __classPrivateFieldGet(this, _TimelineBoxAdapter_terminator, "f").own(new Terminator());
        const updateTempoAutomation = () => __classPrivateFieldGet(this, _TimelineBoxAdapter_tempoAutomation, "f").notify(__classPrivateFieldGet(this, _TimelineBoxAdapter_resolveTempoAutomation, "f").call(this));
        const { tempoTrack: { events, enabled } } = box;
        __classPrivateFieldGet(this, _TimelineBoxAdapter_terminator, "f").own(events.catchupAndSubscribe(({ targetVertex }) => {
            tempoAutomationLifecycle.terminate();
            targetVertex.match({
                none: () => __classPrivateFieldGet(this, _TimelineBoxAdapter_tempoTrackEvents, "f").clear(),
                some: ({ box }) => {
                    const eventCollectionAdapter = context.boxAdapters.adapterFor(box, ValueEventCollectionBoxAdapter);
                    __classPrivateFieldGet(this, _TimelineBoxAdapter_tempoTrackEvents, "f").wrap(eventCollectionAdapter);
                    tempoAutomationLifecycle.ownAll(eventCollectionAdapter.subscribeChange(updateTempoAutomation), enabled.subscribe(updateTempoAutomation));
                }
            });
        }));
    }
    // For dsp. It does not care why events are not available. We just send Option.None if disabled or no events present.
    catchupAndSubscribeTempoAutomation(observer) {
        observer(__classPrivateFieldGet(this, _TimelineBoxAdapter_resolveTempoAutomation, "f").call(this));
        return __classPrivateFieldGet(this, _TimelineBoxAdapter_tempoAutomation, "f").subscribe(observer);
    }
    get box() { return __classPrivateFieldGet(this, _TimelineBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _TimelineBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _TimelineBoxAdapter_box, "f").address; }
    get markerTrack() { return __classPrivateFieldGet(this, _TimelineBoxAdapter_markerTrack, "f"); }
    get signatureTrack() { return __classPrivateFieldGet(this, _TimelineBoxAdapter_signatureTrack, "f"); }
    get tempoTrackEvents() { return __classPrivateFieldGet(this, _TimelineBoxAdapter_tempoTrackEvents, "f"); }
    get signature() {
        const { nominator, denominator } = __classPrivateFieldGet(this, _TimelineBoxAdapter_box, "f").signature;
        return [nominator.getValue(), denominator.getValue()];
    }
    get signatureDuration() {
        const { nominator, denominator } = __classPrivateFieldGet(this, _TimelineBoxAdapter_box, "f").signature;
        return PPQN.fromSignature(nominator.getValue(), denominator.getValue());
    }
    catchupAndSubscribeSignature(observer) {
        observer(this.signature);
        return __classPrivateFieldGet(this, _TimelineBoxAdapter_box, "f").signature.subscribe(() => observer(this.signature));
    }
    terminate() { __classPrivateFieldGet(this, _TimelineBoxAdapter_terminator, "f").terminate(); }
}
_TimelineBoxAdapter_terminator = new WeakMap(), _TimelineBoxAdapter_box = new WeakMap(), _TimelineBoxAdapter_markerTrack = new WeakMap(), _TimelineBoxAdapter_signatureTrack = new WeakMap(), _TimelineBoxAdapter_tempoTrackEvents = new WeakMap(), _TimelineBoxAdapter_tempoAutomation = new WeakMap(), _TimelineBoxAdapter_resolveTempoAutomation = new WeakMap();
